var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCutlery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 240.268,
    height: 238.534,
    viewBox: "0 0 240.268 238.534",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cutlery-svgrepo-com",
    transform: "translate(-0.84 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54988",
    "data-name": "Path 54988",
    d: "M10.523,1.394A10.842,10.842,0,0,1,21.084,4.176L237.933,221.025A10.842,10.842,0,0,1,222.6,236.358l-79.073-79.073-11.773,11.773a21.674,21.674,0,0,1-30.659.008L27.436,95.407C8.9,76.868,2.779,55.236,1.264,38.575A103.571,103.571,0,0,1,1.455,17.93a67.2,67.2,0,0,1,1.438-8.7A10.944,10.944,0,0,1,10.523,1.394ZM22.861,36.62c1.2,13.154,5.923,29.468,19.909,43.453l73.651,73.652,11.773-11.773Z",
    transform: "translate(0 0)",
    fill: "#1890ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54989",
    "data-name": "Path 54989",
    d: "M69.457,4.676a10.843,10.843,0,0,1,0,15.333l-31.4,31.4c-3.863,3.863-3.912,9.443-1.223,13.925L75.809,26.361A10.842,10.842,0,0,1,91.142,41.694L52.171,80.666c4.481,2.689,10.062,2.64,13.925-1.222l31.4-31.4a10.842,10.842,0,1,1,15.333,15.333l-31.4,31.4a32.525,32.525,0,0,1-39.735,4.892l-5.329-3.2-4.856,4.856A10.842,10.842,0,0,1,16.176,85.994l4.856-4.856-3.2-5.329a32.528,32.528,0,0,1,4.892-39.735l31.4-31.4A10.842,10.842,0,0,1,69.457,4.676Z",
    transform: "translate(119.684 4.921)",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54990",
    "data-name": "Path 54990",
    d: "M79.143,34.009A10.842,10.842,0,0,0,63.809,18.676L4.176,78.309A10.842,10.842,0,0,0,19.509,93.642Z",
    transform: "translate(1.575 142.716)",
    fill: "#1890ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCutlery);
export default __webpack_public_path__ + "static/media/cutlery.2732e22b8c749af83a6de53ec1128471.svg";
export { ForwardRef as ReactComponent };